import React from 'react'
import "./Apropos.css"
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Apropos() {
      const { t, i18n } = useTranslation();
  
      const changeLanguage = (e) => {
        i18n.changeLanguage(e.target.value);
    };


  return (
    <div id='Apropos' className='Apropos_container' >
      <div className='Apropos_text' data-aos="fade-up" >
        <h3 className='titre' >{t('Apropos.title')}</h3><br></br>
        <div className='Apropos_paragraphs plf'>
          <p>
           {t('Apropos.p1')}</p><br></br>
          <p className='para_hd' >{t('Apropos.p2')}
          </p></div><br></br>
        <RouterLink to="/Infos" className=' plf Apropos_button'>
          {t('Apropos.button')}
        </RouterLink>
      </div>
      <div className='Apropos_image' >
        <img src="/assets/Photo/apropos.png" alt="apropos" />
      </div>
    </div>
  )
}

export default Apropos;